function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 4,
  fill: "#005646"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.936 9.208c-1.582 2.583-.287 4.652.15 5.228-.531.938-.94 1.971-1.082 3.056A.454.454 0 008.47 18a.464.464 0 00.464-.395c.472-3.583 4.335-6.713 4.903-7.155.149-.032.426-.045.564.233.11.223.038.38.009.428-2.368 2.157-3.395 3.644-2.971 4.3a.491.491 0 00.412.212c1.72-.052 3.02-.643 3.862-1.76 2.01-2.66.628-7.34.568-7.538a.461.461 0 00-.332-.31.482.482 0 00-.448.115c-.832.792-1.85.962-2.929 1.142-1.342.224-2.73.455-3.636 1.936z",
  fill: "#A4E7DB"
});

function SvgLeafWithBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgLeafWithBackground;